import React from 'react';
import PropTypes from 'prop-types';
import { Left, Container, InfoIcon, Right, MessageContainer } from './styled-components';

import { ICONS, COLORS } from '../../../../utils/styles';

const Notification = ({ message }) => (
  <Container>
    <Left xs={1}>
      <InfoIcon icon={ICONS.ALERT} color={COLORS.athensGray} />
    </Left>
    <Right xs={10}>
      <MessageContainer>{message}</MessageContainer>
    </Right>
  </Container>
);

Notification.propTypes = {
  message: PropTypes.string.isRequired
};

export default Notification;



// WEBPACK FOOTER //
// ./src/views/common/components/Notification/index.jsx